module.exports = __webpack_public_path__ + "img/yin-yang.dad5d823.svg";